export default __webpack_public_path__ + "static/media/PSC-Logo.d707e19b.png";